import { render, staticRenderFns } from "./users.html?vue&type=template&id=00b04b58&scoped=true&"
import script from "./users.js?vue&type=script&lang=js&"
export * from "./users.js?vue&type=script&lang=js&"
import style0 from "./users.scss?vue&type=style&index=0&id=00b04b58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b04b58",
  null
  
)

export default component.exports